import { useTranslation } from 'react-i18next'

const SkatePark = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="skatepark-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="skatepark-title">{t('antagonists:league:components:background')}</title>
      <defs>
        <clipPath id="skatepark-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="skatepark-c">
          <path
            d="M1602.05 615.87c44.77 2.91 79.3-27.72 77.28-74.74-2.03-47.02-28.22-54.84-38.59-74.79-7.61-14.64 4.32-72.77-28.16-90.68-32.48-17.91-44.96-6.54-61.09-21.1-19.57-17.66-37.12-76.83-113.49-53.02-46.25 14.42-36.88 69.92-52.08 86.81-19.81 22.01-47.31 20.27-54.06 50.69-7.88 35.47 4.19 51.66 12.53 66.26 9.44 16.52-30.56 78.73 9.44 102.69 49.49 29.65 90.22-11.69 147.07-7.21 56.84 4.48 66.67 12.86 101.18 15.1Z"
            style={{
              fill: '#009250',
            }}
          />
        </clipPath>
        <clipPath id="skatepark-d">
          <path
            d="M117.56 640.74c-57.74-6.28-97.95-49.37-83.89-123.19 9.52-50 66.67-69.05 57.47-133.86-5.05-35.57-45.57-59.01-26.52-128.06 15.11-54.77 94.38-69.67 120.69-93.06 29.27-26.02 43.66-93.55 162.61-90.46s119.27 136.88 136.94 162.32c17.44 25.1 79.67 48.1 100.91 86.08 35.75 63.91 4.11 101.43-2.35 127.88-6.06 24.84 39.97 123.76-45.82 169.65-69.42 37.13-118.19-9.71-218.28-2.56-100.1 7.15-152.32 30.64-201.77 25.26Z"
            style={{
              fill: '#78a937',
            }}
          />
        </clipPath>
        <clipPath id="skatepark-e">
          <path
            d="m1984.86 715.75-225.12 1.24s-37.58 106.08-175.94 117.4c-193.03 15.8-943.61 17.06-1047.26 2.25-141.41-20.2-149.98-140.15-149.98-140.15l-428.83-.31-160.09 92.79s334.45 450.67 345.69 437.56c13.47-15.71 1741.24-1.58 1730.01-3.83-11.22-2.24 111.51-506.96 111.51-506.96Z"
            style={{
              fill: '#e2e2e4',
            }}
          />
        </clipPath>
        <clipPath id="skatepark-f">
          <path
            d="M402.39 766.73c-13.92 5.45-15.54 16.96-7.18 27.93 12.3 16.15 41.77 28.96 84.57 50.74 42.09 21.42 86.94 44.52 97.64 46.9 13.84 3.08 52.54 8.71 78.93-3.84 21.43-10.2 25.63-20.25 17.94-26.4-7.69-6.15-19.22-6.66-28.7-10.25-11.23-4.25-166.07-66.89-176.06-71.24-9.99-4.36-37.67-25.37-67.14-13.84Z"
            style={{
              fill: '#bba562',
            }}
          />
        </clipPath>
        <style>
          {
            '.h,.i{fill:none}.j{fill:#f6f6f7}.k{fill:#009250}.l{fill:#ed7925}.m{fill:#ffee39}.n{fill:#ffed00}.o{fill:#ffd500}.p{fill:#e6ab00}.q{fill:#e2e2e4}.r{fill:#803a86}.s{fill:#00a183}.t{fill:#bba562}.u{fill:#df2e87}.v{fill:#d4d5e5}.w{fill:#e41c80}.x{fill:#ca332e}.y{fill:#235a96}.aa{fill:#47823c}.ab{fill:#313e36}.ac{fill:#58873f}.ad{fill:#5b3346}.ae{fill:#78a937}.af{fill:#78877b}.ag{fill:#83988d}.ah{clip-path:url(#skatepark-c)}.ai{clip-path:url(#skatepark-b)}.aj{clip-path:url(#skatepark-f)}.ak{clip-path:url(#skatepark-e)}.al{clip-path:url(#skatepark-d)}.i{stroke:#1a171b}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#skatepark-b)',
        }}
        id="skatepark-a"
      >
        <path
          style={{
            fill: '#d4d5e5',
          }}
          d="M-65.85-191.33h2113.96v1294.39H-65.85z"
        />
        <path
          style={{
            fill: 'none',
            stroke: '#1a171b',
          }}
          d="M-65.85-191.33h2113.96v1294.39H-65.85z"
        />
        <path
          d="M125.68 576.66s3.49 64.5 5.23 99.37c1.74 34.87-5.62 113.7-5.62 113.7l-19.18-1.74s4.75-88.42 3.87-119.8c-.87-31.38-3.49-92.39-3.49-92.39l19.18.87Z"
          style={{
            fill: '#5b3346',
          }}
        />
        <path
          d="M621.25 531.59c-77.16-10.8-119.16 26.9-130.52 76.79-11.85 52.3 4.9 116.68 77.27 134.18 73.62 17.8 140.71-29.78 145.22-85.1 4.21-52.76-14.82-115.07-91.97-125.88Z"
          style={{
            fill: '#ffed00',
          }}
        />
        <path
          d="M11.32 665.24c-25.26-14.49-62.01-61.61-43.47-105.86 14.54-34.7 36.11-34.63 34.34-58.06-1.77-23.43-26.03-67.62-7.24-95.76 16.59-24.85 34.6-23.59 46.84-38.77 13.62-16.89 9.33-62.82 64.95-58.81 74.44 5.36 95.81 92.41 104.15 109.16 8.22 16.53 30.26 30.53 40.3 55.51 16.89 42.03-7.88 59.8-10.83 77.08-2.77 16.23 50.59 76.19 3.74 107.34-33.08 22-76.95 7.93-123.75 12.09s-82.48 11.32-109.03-3.92Z"
          style={{
            fill: '#58873f',
          }}
        />
        <path
          d="M189.07 515.46s-5.26 97.34-7.89 149.96c-2.63 52.62 1.32 99.98 1.32 99.98l28.94-2.63s0-61.83 1.32-109.18c1.32-47.36 5.26-139.44 5.26-139.44l-28.94 1.32Z"
          style={{
            fill: '#5b3346',
          }}
        />
        <path
          d="M1413.31 167.69c-6.23 3.54-41.59 5.98-41.59 39.15 0 30.13 24.1 34.35 30.62 35.67 13.7 2.78 101.22 2.1 128.15-.55 13.06-1.29 40.82-10.23 34.41-42.75-7.45-37.82-48.62-37.85-53.96-40.98s-14.18-36.66-54.2-32.5c-35.31 3.67-37.22 38.41-43.45 41.96Z"
          style={{
            fill: '#f6f6f7',
          }}
        />
        <path
          d="M1535.28 544.27s3.49 64.5 5.23 99.37c1.74 34.87-.87 66.24-.87 66.24l-19.18-1.74s0-40.97-.87-72.35c-.87-31.38-3.49-92.39-3.49-92.39l19.18.87Z"
          style={{
            fill: '#5b3346',
          }}
        />
        <path
          d="M1602.05 615.87c44.77 2.91 79.3-27.72 77.28-74.74-2.03-47.02-28.22-54.84-38.59-74.79-7.61-14.64 4.32-72.77-28.16-90.68-32.48-17.91-44.96-6.54-61.09-21.1-19.57-17.66-37.12-76.83-113.49-53.02-46.25 14.42-36.88 69.92-52.08 86.81-19.81 22.01-47.31 20.27-54.06 50.69-7.88 35.47 4.19 51.66 12.53 66.26 9.44 16.52-30.56 78.73 9.44 102.69 49.49 29.65 90.22-11.69 147.07-7.21 56.84 4.48 66.67 12.86 101.18 15.1Z"
          style={{
            fill: '#009250',
          }}
        />
        <g
          style={{
            clipPath: 'url(#skatepark-c)',
          }}
        >
          <path
            d="M1680.13 280.88c4.61 2.07 74.9 78.65 34.35 154.02-40.55 75.37-94.65 68.61-125.15 103.64-46.67 53.6 18.18 120.46 18.18 120.46s-102.57 88.18-189.53 44.65c-86.96-43.53-92.21-176.62-60.29-266.65 31.92-90.04 127.19-27.34 139.8-93.69 12.62-66.35 104.74-97.51 182.64-62.43Z"
            style={{
              fill: '#00a183',
            }}
          />
          <path
            d="M1554.36 228.99c4.45 1.69 75.19 70.68 42.1 145.86-33.08 75.19-84.16 72.28-110.44 108-40.22 54.65 24.81 114.66 24.81 114.66s-90.3 91.63-174.51 55.54c-84.21-36.09-97.73-163.75-73.67-252.47 24.06-88.72 117.28-34.74 124.79-99.4 7.52-64.66 91.73-100.75 166.92-72.18Z"
            style={{
              fill: '#78a937',
            }}
          />
          <path
            d="M1385.62 240.29c48.57 25.06 139.52 102.34 106.44 185.91-33.08 83.57-124.06 70.17-145.11 140.37-21.05 70.2 42.1 104.16 42.1 104.16s-99.67 74.72-183.88 34.61-97.73-182.01-73.67-280.62c24.06-98.61 117.28-38.61 124.8-110.48 7.52-71.87 80.75-99 129.32-73.94Z"
            style={{
              fill: '#47823c',
            }}
          />
        </g>
        <path
          d="M1487.59 557.52c0 2.61 1.74 57.53 2.62 95.01.87 37.48 5.23 88.91 5.23 88.91l-17.43-4.36s-6.1-83.68-7.84-91.52c-1.74-7.84-14.82-27.02-24.41-37.48-9.59-10.46-13.7-14.57-13.7-14.57l4.36-5.23s11.96 8.47 18.06 16.31c6.1 7.84 14.82 21.79 14.82 21.79s.87-33.12 0-42.71c-.87-9.59 3.49-29.64 3.49-29.64l14.82 3.49Z"
          style={{
            fill: '#5b3346',
          }}
        />
        <path
          d="m-150.65 1162.31-125.44-459.78s513.83 45.72 871.2 13.07c199.56-18.23 231.99-36.56 529.11-45.58 100.3-3.04 392.58-2.79 638.3 1.84 205.67 3.87 435.44-12.5 435.44-12.5l-282.24 528.6-2066.38-25.64Z"
          style={{
            fill: '#e6ab00',
          }}
        />
        <path
          d="M524.47 1320.13 46.45 755.28s482.04 65.25 764.94 32.41c296.49-34.42 411.24-71.18 652.58-86.43 395.65-25 1019.86 6.7 1019.86 6.7l-14.21 459.41-1945.15 152.76Z"
          style={{
            fill: '#ed7925',
          }}
        />
        <path
          d="M117.56 640.74c-57.74-6.28-97.95-49.37-83.89-123.19 9.52-50 66.67-69.05 57.47-133.86-5.05-35.57-45.57-59.01-26.52-128.06 15.11-54.77 94.38-69.67 120.69-93.06 29.27-26.02 43.66-93.55 162.61-90.46s119.27 136.88 136.94 162.32c17.44 25.1 79.67 48.1 100.91 86.08 35.75 63.91 4.11 101.43-2.35 127.88-6.06 24.84 39.97 123.76-45.82 169.65-69.42 37.13-118.19-9.71-218.28-2.56-100.1 7.15-152.32 30.64-201.77 25.26Z"
          style={{
            fill: '#78a937',
          }}
        />
        <g
          style={{
            clipPath: 'url(#skatepark-d)',
          }}
        >
          <path
            d="M534.01 751.68c7.89-2.74 173.93-127.67 132.15-286.93-41.79-159.26-181-118.3-197.44-229.55-12.87-87.11 71.31-92.25 81.04-196.73C559.49-66.01 455.35-185.66 305-125.3 154.66-64.94 96.13 195.75 116.97 299.16c36.96 183.36 146.52 144.3 146.82 277.9.3 133.6 136.69 221.03 270.22 174.62Z"
            style={{
              fill: '#00a183',
            }}
          />
          <path
            d="M315.25-7.21c-7.6 2.89-180.92 93.73-124.35 222.3 56.57 128.58 211.08 109.34 237.9 200.15 21 71.11-62.32 81.94-62.19 169.2.13 87.26 177.5 195.24 321.51 133.52 144-61.72 126-231.44 84.86-383.16-41.14-151.72-159.43-108-172.29-218.58C587.83 5.65 443.82-56.07 315.25-7.21Z"
            style={{
              fill: '#47823c',
            }}
          />
        </g>
        <path
          d="M321.87 521c0 3.95-2.63 84.35-3.95 140.92-1.32 56.56-7.89 134.18-7.89 134.18l26.31-6.58s9.21-126.28 11.84-138.12c2.63-11.84 12.32-39.44 26.79-55.23 14.47-15.79 23.7-18.23 23.7-18.23l-6.38-7.29s-17.23 6.39-26.44 18.23-17.12 24.39-17.12 24.39-4.43-25.91-3.11-40.38c1.32-14.47-1.39-57.15-1.39-57.15L321.87 521Z"
          style={{
            fill: '#5b3346',
          }}
        />
        <path
          style={{
            fill: '#78877b',
          }}
          d="m1644.11 77.07 74.57 780.34 35.07-5.48-93.29-776.26-16.35 1.4z"
        />
        <path
          style={{
            fill: '#78877b',
          }}
          d="m1650.05 106.46-120.91 15.57 9.42 79.9 121.02-15.39-9.53-80.08z"
        />
        <path
          style={{
            fill: '#ffee39',
          }}
          d="m1644.72 112.6-106.89 13.93 8.14 69.28 107-13.76-8.25-69.45z"
        />
        <path
          style={{
            fill: '#78877b',
          }}
          d="m1649.68 146.69-110.98 12.38.37 4.12 111.14-12.63-.53-3.87z"
        />
        <path
          style={{
            fill: '#78877b',
          }}
          d="m1616.81 112.41 8.75 74.15 4.11-.46-8.99-74.25-3.87.56zM1588.9 117.29l8.74 74.16 4.11-.46-8.99-74.25-3.86.55zM1560.04 120.21l8.74 74.16 4.11-.46-8.99-74.25-3.86.55zM1782.28 88.71l-120.91 15.57 9.42 79.89 121.03-15.38-9.54-80.08z"
        />
        <path
          style={{
            fill: '#ffee39',
          }}
          d="m1776.96 94.85-106.89 13.92 8.14 69.29 107-13.76-8.25-69.45z"
        />
        <path
          style={{
            fill: '#78877b',
          }}
          d="m1781.91 128.94-110.97 12.38.37 4.12 111.13-12.63-.53-3.87z"
        />
        <path
          style={{
            fill: '#78877b',
          }}
          d="m1749.05 94.66 8.74 74.15 4.11-.46-8.99-74.25-3.86.56zM1721.13 99.54l8.74 74.16 4.12-.46-8.99-74.25-3.87.55zM1692.27 102.46l8.74 74.16 4.12-.46-8.99-74.25-3.87.55z"
        />
        <path
          d="m1984.86 715.75-225.12 1.24s-37.58 106.08-175.94 117.4c-193.03 15.8-943.61 17.06-1047.26 2.25-141.41-20.2-149.98-140.15-149.98-140.15l-428.83-.31-160.09 92.79s334.45 450.67 345.69 437.56c13.47-15.71 1741.24-1.58 1730.01-3.83-11.22-2.24 111.51-506.96 111.51-506.96Z"
          style={{
            fill: '#e2e2e4',
          }}
        />
        <g
          style={{
            clipPath: 'url(#skatepark-e)',
          }}
        >
          <path
            style={{
              fill: 'none',
            }}
            d="m285.07 801.96 111.3-116.83L3.33 659.34-97.38 785.85l382.45 16.11zM1782.11 807.39l-29.42-116.64 316.8-17.37 100.72 126.51-388.1 7.5z"
          />
        </g>
        <path
          id="ENVIRONMENT_BACKGROUND"
          d="m-48.51 763.27 372.72-2.81s29.14 197.21 298.19 198.26c360.86 1.41 810.38 3.61 920.4-4.39 171-12.44 233.51-171.21 233.51-171.21l279.86-.73-11.28 511.33-2083.2 52.18-10.2-582.63Z"
          style={{
            fill: '#83988d',
          }}
        />
        <path
          style={{
            fill: '#803a86',
          }}
          d="m430.61 822.19 9.86-3.75 8.03 8.18-14.06 3.92-3.83-8.35zM571.22 898.67l15.1-7.24s-13.94-14.74-13.94-14.48-11.62 15.1-11.62 15.1l10.46 6.61Z"
        />
        <path
          d="M418.16 822.38s-5.66 2.91-1.94 11.15 9.05 7.6 9.05 7.6l8.4-2.75s4.85-5.98 1.21-12.61c-3.64-6.63-7.52-6.47-7.52-6.47l-9.21 3.07Z"
          style={{
            fill: '#df2e87',
          }}
        />
        <path
          d="M418.96 829.75c-.71.51-.54 2 .04 3.19.58 1.19 1.42 1.77 2.35 1.54s.81-2.31.04-3.43-1.89-1.69-2.43-1.31Z"
          style={{
            fill: '#803a86',
          }}
        />
        <path
          d="M549.6 893.66s-4.56 8.49 1.97 15.73c6.52 7.24 11.62 4.91 11.62 4.91s8.39-4.54 8.67-4.83c.98-.98 7.19-6.44-.36-16.98-5.18-7.24-12.87-5-12.87-5l-9.03 6.17Z"
          style={{
            fill: '#df2e87',
          }}
        />
        <path
          d="M554.43 901.29c-.95.65-.76 2.69.12 3.87.88 1.18 2.23 2.03 3.49 1.14 1.26-.88-.02-3.59-.7-4.27s-2.03-1.34-2.91-.74Z"
          style={{
            fill: '#803a86',
          }}
        />
        <path
          d="M402.39 766.73c-13.92 5.45-15.54 16.96-7.18 27.93 12.3 16.15 41.77 28.96 84.57 50.74 42.09 21.42 86.94 44.52 97.64 46.9 13.84 3.08 52.54 8.71 78.93-3.84 21.43-10.2 25.63-20.25 17.94-26.4-7.69-6.15-19.22-6.66-28.7-10.25-11.23-4.25-166.07-66.89-176.06-71.24-9.99-4.36-37.67-25.37-67.14-13.84Z"
          style={{
            fill: '#bba562',
          }}
        />
        <g
          style={{
            clipPath: 'url(#skatepark-f)',
          }}
        >
          <path
            d="M404.22 762.97c-13.82 5.4-15.43 16.82-7.13 27.7 12.21 16.01 41.48 28.72 83.98 50.32 41.79 21.24 86.33 44.15 96.95 46.51 13.74 3.05 52.17 8.64 78.38-3.81 21.28-10.11 25.45-20.08 17.81-26.18-7.63-6.1-19.09-6.61-28.5-10.17-11.15-4.21-164.9-66.33-174.82-70.65-9.92-4.32-37.41-25.16-66.67-13.72Z"
            style={{
              fill: '#313e36',
            }}
          />
        </g>
        <path
          d="M1464.87 835.02c.3.41.03.77-.19.98s-.55.19-.74 0-.18-.5.14-.88.62-.35.8-.1ZM1476.57 910.4l-30.23-11.6-30.65 10.89-2.34-7 28.21-12.48 12.68-29.59 5.29 6.03-10.34 26.12 26.44 8.98.94 8.65z"
          style={{
            fill: '#313e36',
          }}
        />
        <path
          d="M1449.05 889.07c3.41 2.75 3.39 6.6 1.21 9.39-2.3 2.95-6.6 3.32-9.64.79-3.04-2.53-3.17-6.88-.83-9.53 2.18-2.47 6.03-3.25 9.26-.64Zm-7.44 2.25c-1.51 1.71-1.43 4.51.53 6.15 1.96 1.63 4.73 1.39 6.21-.51 1.4-1.8 1.41-4.28-.78-6.05-2.08-1.68-4.56-1.17-5.97.41Z"
          style={{
            fill: '#ffed00',
          }}
        />
        <path
          d="M1521.4 848.7c15.43 26.54 5.85 47.73-4.07 54.11-9.93 6.39-28.82 15.08-29.22 15.56s-9.1 2.46-14.87-7.22c-5.77-9.69.42-11.59 4.53-15.22 4.11-3.63 4.93-7.56 1.16-14.76-3.77-7.21-6.33-10.97-11.06-10.83-4.73.14-9.45 3.53-14.36-3.27-4.92-6.8 3.22-11.69.15-16.15-3.07-4.46-18.06-25.88-18.06-25.88s25.32-16.09 42.49-11.29c17.17 4.79 36.3 22.88 43.32 34.97Z"
          style={{
            fill: '#ca332e',
          }}
        />
        <path
          style={{
            fill: '#e41c80',
          }}
          d="m1454.62 830.39 6.4-2.87-4.83-8.61-6.65 3.08 5.08 8.4z"
        />
        <path
          d="M1544.43 857.52c.49.13.51.58.47.88s-.31.49-.57.47-.45-.27-.45-.76.25-.66.56-.58Z"
          style={{
            fill: '#313e36',
          }}
        />
        <path
          style={{
            fill: '#235a96',
          }}
          d="m1599.5 907.72-29.78 11.09-3.76 22.99-8.09-1.01 3.32-24.44-10.47-33.05 7.91 1.33 9.5 26.09 25.17-9.1 6.2 6.1z"
        />
        <path
          d="M1566.37 909.39c4.37-.03 6.8 2.97 6.88 6.51.08 3.74-3.01 6.74-6.97 6.71s-6.81-3.32-6.67-6.86c.13-3.29 2.61-6.33 6.76-6.35Zm-4.34 6.45c-.09 2.28 1.75 4.4 4.3 4.42s4.54-1.91 4.49-4.32c-.05-2.28-1.62-4.21-4.44-4.19-2.67.02-4.28 1.98-4.36 4.1Z"
          style={{
            fill: '#58b6e3',
          }}
        />
        <path
          d="M1596.86 832.35c28.74 10.79 34.73 33.26 31.08 44.49-3.65 11.23-12.78 29.91-12.79 30.54 0 .63-5.49 7.67-16.09 3.82s-7.01-9.24-6.12-14.65c.88-5.41-.96-8.97-8.44-12.17-7.48-3.2-11.84-4.49-15.42-1.39-3.57 3.1-5.08 8.71-13.19 6.55-8.11-2.16-4.9-11.1-10.1-12.6-5.2-1.51-30.36-8.61-30.36-8.61s9.43-28.48 25.76-35.63c16.33-7.15 42.58-5.24 55.67-.33Z"
          style={{
            fill: '#ffed00',
          }}
        />
        <path
          style={{
            fill: '#ffd500',
          }}
          d="m1533.55 860.42 2.27-6.83-7.78-3.36-3.73 6.9 9.24 3.29z"
        />
      </g>
    </svg>
  )
}

export default SkatePark
